import { observer } from 'mobx-react'
import React, { Component, Fragment } from 'react'
import Button from '../../components/Button'
import Card from '../../components/Card'
import Header from '../../components/Header'
import Paginate from '../../components/Paginate'
import Prompts from '../../components/Prompts'
import Row from '../../components/Row'
import SectionHeader from '../../components/SectionHeader'
import UseStep from '../../components/UseStep'
import UseTip from '../../components/UseTip'
import UseVideo from '../../components/UseVideo'
import patient from '../../stores/patient'

@observer
export default class UseContent extends Component {
  render() {
    const { patientID, session, demo } = this.props
    const firstSession = session === 'first'
    const secondSession = session === 'second'
    const thirdSession = session === 'third'

    return (
      <Fragment>
        {/* EYE DROPS USE */}
        <SectionHeader color="orange" icon="fas fa-tint" str="titles.eyeDropsUse" />
        <Prompts>
          {firstSession &&
            <Fragment>
              <Prompts.Q str="prose.problemsPuttingInDrops" />
              <Prompts.R str="prose.itSoundsLike" />
              <Prompts.Q str="prose.wouldLikeToSeeDrops" />
              <Prompts.R str="prose.thanksForShowing" />
              {patient.fields.lowVision === "YES"? <Prompts.P str="prose.differentWaysDropsLowVision"/>:<Prompts.P str="prose.differentWaysDrops" />}
            </Fragment>
          }
          {(secondSession || thirdSession) &&
            <Fragment>
              <Prompts.Q str="prose.ifItsOkayWithYou" />
              <Prompts.P str="prose.coachOnHowToDo" />
              <Prompts.R str="prose.reflectOnThingsDoingWell2" />
            </Fragment>
          }
        </Prompts>
        {patient.fields.lowVision === "NO" &&<UseVideo />}
        {/* EYE DROPS USE - METHOD 1 */}
        <Header str="titles.method1" />
        <UseStep image="/images/use/method-1-step-1.jpg" str="prose.washYourHands" />
        <UseStep image="/images/use/method-1-step-2.jpg" str="prose.pullDownEyelid" />
        <UseStep image="/images/use/method-1-step-3.jpg" str="prose.restAFinger" />
        <UseStep image="/images/use/method-1-step-4.jpg" str="prose.lookingInMirror" />
        <UseStep image="/images/use/method-1-step-5.jpg" str="prose.closeEyesForMinute" />
        {firstSession &&
          <Prompts>
            <Prompts.Q str="prose.imagineThisMethod" />
            <Prompts.R str="prose.soundsLikeMethodWorking" />
          </Prompts>
        }
        {/* EYE DROPS USE - METHOD 2 */}
        <Header str="titles.method2" />
        <UseStep image="/images/use/method-2-step-1.jpg" str="prose.washYourHands" />
        <UseStep image="/images/use/method-2-step-2.jpg" str="prose.layDownOnBack" />
        <UseStep image="/images/use/method-2-step-3.jpg" str="prose.restFingerCloseEyes" />
        <UseStep image="/images/use/method-2-step-4.jpg" str="prose.blinkUntilFeel" />
        <UseStep image="/images/use/method-2-step-5.jpg" str="prose.closeEyesForMinute" />
        {(secondSession || thirdSession) &&
          <Prompts>
            <Prompts.S str="prose.ifReviewedMethods" />
          </Prompts>
        }
        {firstSession &&
          <Prompts>
            <Prompts.Q str="prose.imagineThisMethod" />
            <Prompts.R str="prose.soundsLikeMethodWorking" />
            <Prompts.Q str="prose.reviewedDifferentMethods" />
          </Prompts>
        }
        {firstSession &&
          <Fragment>
            {/* USAGE TIPS */}
            <SectionHeader color="orange" icon="fas fa-lightbulb" str="titles.usageTips" />
            <Prompts>
              <Prompts.P str="prose.shareAdditionalTips" />
            </Prompts>
            {/* The images for these are out of order :/. */}
            {/* Right now, the order is: 1, 4, 2, 3, 5, 6. */}
            <UseTip image="/images/use/icon-tip-1.png" str="prose.orderDoesntMatter" />
            <UseTip image="/images/use/icon-tip-4.png" str="prose.waitFiveMinutes" />
            <UseTip image="/images/use/icon-tip-2.png" str="prose.takeDropsSameTime" />
            {/* 20190823 - Modify the image for this one */}
            <UseTip image="/images/use/icon-tip-7.png" str="prose.notTouchTip"/>
            <UseTip image="/images/use/icon-tip-3.png" str="prose.putInYourDrop" />
            <UseTip image="/images/use/icon-tip-5.png" str="prose.dontWorrySpills" />
            <UseTip image="/images/use/icon-tip-6.png" str="prose.checkRefrigeration" />
            <Prompts>
              <Prompts.Q str="prose.wasThisNewInformation" />
              <Prompts.R str="prose.reflectBackWhatWas" />
              <Prompts.S str="prose.sharedWithMeDrops" />
            </Prompts>
            {/* PDF DOWNLOADS */}
            <SectionHeader color="orange" icon="fas fa-download" str="titles.pdfDownloads" />
            <Card>
              {patient.fields.lowVision === "YES"? <Card.Title str="titles.downloadPDFLowVision"/>:<Card.Title str="titles.downloadPDF" />}
              <Card.Pad>
                <Row>
                  <Row.Cell>
                    <Button
                      color="orange"
                      str="titles.method1"
                      onClick={() => window.open('/documents/use-method-1.pdf', '_blank')}
                    />
                  </Row.Cell>
                  <Row.Cell>
                    <Button
                      color="orange"
                      str="titles.method2"
                      onClick={() => window.open('/documents/use-method-2.pdf', '_blank')}
                    />
                  </Row.Cell>
                  <Row.Cell>
                    <Button
                      color="orange"
                      str="titles.both"
                      onClick={() => window.open('/documents/use-both-methods.pdf', '_blank')}
                    />
                  </Row.Cell>
                </Row>
              </Card.Pad>
            </Card>
          </Fragment>
        }
        {(secondSession || thirdSession) &&
          <Fragment>
            {/* USAGE TIPS */}
            <SectionHeader color="orange" icon="fas fa-lightbulb" str="titles.usageTips" />
            <Prompts>
              <Prompts.P str="prose.noNeedTo" />
            </Prompts>
            {/* The images for these are out of order :/. */}
            {/* Right now, the order is: 1, 4, 2, 3, 5, 6. */}
            <UseTip image="/images/use/icon-tip-1.png" str="prose.orderDoesntMatter" />
            <UseTip image="/images/use/icon-tip-4.png" str="prose.waitFiveMinutes" />
            <UseTip image="/images/use/icon-tip-2.png" str="prose.takeDropsSameTime" />
            {/* 20190823 - Modify the image for this one */}
            <UseTip image="/images/use/icon-tip-7.png" str="prose.notTouchTip"/>
            <UseTip image="/images/use/icon-tip-3.png" str="prose.putInYourDrop" />
            <UseTip image="/images/use/icon-tip-5.png" str="prose.dontWorrySpills" />
            <UseTip image="/images/use/icon-tip-6.png" str="prose.checkRefrigeration" />
          </Fragment>
        }
        {/* PAGINATE */}
        <Paginate>
          {firstSession && demo &&
            <Fragment>
              <Paginate.Button prev
                color="blue"
                str="titles.learn"
                to="/demo/learn"
              />
              <Paginate.Button next
                color="red"
                str="titles.goal"
                to="/demo/goal"
              />
            </Fragment>
          }
          {firstSession && !demo &&
            <Fragment>
              <Paginate.Button prev
                color="blue"
                str="titles.learn"
                to={`/learn/${session}/${patientID}`}
              />
              <Paginate.Button next
                color="red"
                str="titles.goal"
                to={`/goal/${session}/${patientID}`}
              />
            </Fragment>
          }
          {secondSession &&
            <Fragment>
              <Paginate.Button prev
                color="red"
                str="titles.goal"
                to={`/goal/${session}/${patientID}`}
              />
              <Paginate.Button next
                color="purple"
                str="titles.plan"
                to={`/plan/${session}/${patientID}`}
              />
            </Fragment>
          }
          {thirdSession &&
            <Paginate.Button next
              color="purple"
              str="titles.plan"
              to={`/plan/${session}/${patientID}`}
            />
          }
        </Paginate>
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Use/UseContent.js